import { CallToActionsInstance, DailyProgramCta } from '../types/dailyProgram';
import { safeIdCompare } from './utils';

export const ARCHIVED_LABEL = '(archived)';

export interface MultiPropertyItemBase {
  property: string;
}

export interface MultiPropertyItem<T extends MultiPropertyItemBase> {
  properties: Array<T>;
  source?: string;
}

export interface MultiPropertyKind {
  status: 'brand' | 'multi' | 'property' | 'orphan';
  variant: 'ocean' | 'lime' | 'banana' | 'slate';
  icon: 'building' | 'house' | 'question';
}

export function getMultiPropertyKind<T extends MultiPropertyItem<MultiPropertyItemBase>>(
  item?: T
): MultiPropertyKind {
  const kindMap: Record<MultiPropertyKind['status'], Omit<MultiPropertyKind, 'status'>> = {
    brand: { variant: 'ocean', icon: 'building' },
    multi: { variant: 'banana', icon: 'building' },
    property: { variant: 'lime', icon: 'house' },
    orphan: { variant: 'slate', icon: 'question' },
  };

  let status: MultiPropertyKind['status'];
  if (!item || !item.source) {
    status = 'brand';
  } else if (item.properties.length > 1) {
    status = 'multi';
  } else if (safeIdCompare(item.properties[0].property, item.source)) {
    status = 'property';
  } else {
    status = 'orphan';
  }

  return {
    status,
    ...kindMap[status],
  };
}

export const evaluateCallToActions = (
  sourceCtas: CallToActionsInstance,
  parentCtas: DailyProgramCta[]
): DailyProgramCta[] => {
  return sourceCtas.syncWithTemplate ? parentCtas : sourceCtas.values;
};
